/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type BulkImportRowAction =
  (typeof BulkImportRowAction)[keyof typeof BulkImportRowAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkImportRowAction = {
  New: 0,
  AddedToExistingReceipt: 1,
  UpdatesExisting: 2,
  AlreadyImported: 3,
  DuplicateInFile: 4,
  AlreadyImportedNotConnected: 5,
} as const;
